var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18C17.4477 18 17 18.4477 17 19V33.0657C17 33.4651 17.4451 33.7033 17.7773 33.4818L19.5171 32.3219C19.8157 32.1228 20.1981 32.099 20.5191 32.2595L22.6584 33.3292C23.5029 33.7515 24.4971 33.7515 25.3416 33.3292L27.4809 32.2595C27.8019 32.099 28.1843 32.1228 28.4829 32.3219L30.2226 33.4818C30.5549 33.7033 31 33.4651 31 33.0657V19C31 18.4477 30.5523 18 30 18H18ZM20 21C20 20.4477 20.4477 20 21 20H23C23.5523 20 24 20.4477 24 21C24 21.5523 23.5523 22 23 22H21C20.4477 22 20 21.5523 20 21ZM26 21C26 20.4477 26.4477 20 27 20C27.5523 20 28 20.4477 28 21C28 21.5523 27.5523 22 27 22C26.4477 22 26 21.5523 26 21ZM20 25C20 24.4477 20.4477 24 21 24H23C23.5523 24 24 24.4477 24 25C24 25.5523 23.5523 26 23 26H21C20.4477 26 20 25.5523 20 25ZM26 25C26 24.4477 26.4477 24 27 24C27.5523 24 28 24.4477 28 25C28 25.5523 27.5523 26 27 26C26.4477 26 26 25.5523 26 25ZM20 29C20 28.4477 20.4477 28 21 28H23C23.5523 28 24 28.4477 24 29C24 29.5523 23.5523 30 23 30H21C20.4477 30 20 29.5523 20 29ZM26 29C26 28.4477 26.4477 28 27 28C27.5523 28 28 28.4477 28 29C28 29.5523 27.5523 30 27 30C26.4477 30 26 29.5523 26 29Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15C14 14.4477 14.4477 14 15 14H33C33.5523 14 34 14.4477 34 15C34 15.5523 33.5523 16 33 16H15C14.4477 16 14 15.5523 14 15Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsReceiptIcon);
export default __webpack_public_path__ + "static/media/details-receipt-icon.74e7bc0248daba7fc48ce5bc9b81ab35.svg";
export { ForwardRef as ReactComponent };